module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "gift-popup",
    style: ({
      left: _vm.x + 'px',
      top: _vm.y + 'px'
    }),
    on: {
      "mouseenter": function($event) {
        return _vm.$emit('mouseenter')
      },
      "mouseleave": function($event) {
        return _vm.$emit('mouseleave')
      }
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "gift-popup-item",
      on: {
        "click": function($event) {
          return _vm.handleZs(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ad01b5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/popup.vue
// module id = 967
// module chunks = 1